import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTheme, withStyles } from 'material-ui/styles'
import _ from 'lodash'
import qs from 'query-string'

import IconButton from 'material-ui/IconButton'
import List, {
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction
} from 'material-ui/List'
import Icon from 'material-ui/Icon'
import { HashLink as Link } from 'react-router-hash-link'

// import Divider from 'material-ui-effco/Divider'
import Menu, { MenuItem } from 'material-ui/Menu'
import Typography from 'material-ui/Typography'

const styles = theme => ({
  drawerPaper: {
    marginTop: 145,
    marginLeft: 8,
    width: 302,
    height: 'calc(100% - 156px)', //-145px
    boxShadow:
      '0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)'
  },
  typographyRoot: {
    fontSize: '0.85rem',
    color: theme.palette.primary.main,
    paddingBottom: '11px'
  },
  listItemTextRoot: {
    fontSize: '0.8rem',
    padding: '3px 16px' //when Link is applied,
    // padding: '13px 16px'
  },
  listItemIconRoot: {
    // paddingTop: '12px',
    fontSize: '18px',
    width: '18px',
    height: '18px'
  },
  listItemDefault: {
    paddingTop: '0px !important',
    paddingBottom: '0px !important'
  },
  listItemSecondaryActionRoot: {
    marginTop: '-29px !important'
  }
})

class DrawerContent extends Component {
  state = {
    anchorEl: null
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = (index, editType, formIndex) => {
    const {
      history: { push },
      match: {
        params: { id }
      },
      path,
      forms
    } = this.props

    const formName = this.matchForm(forms, formIndex)

    this.setState({ anchorEl: null })
    const editTypeId = _.get(_.find(editType, ['id', index]), 'id') || -1
    if (editTypeId > -1)
      push(`${path}${id}/${formName}?view=edit&editType=${editTypeId}`)
  }

  matchForm = (forms, value, id = true) => {
    return id
      ? _.get(
          forms,
          `[${_.findIndex(forms, ['id', value])}].name`,
          forms[0].name || ''
        )
      : _.get(
          forms,
          `[${_.findIndex(forms, ['name', value])}].id`,
          forms[0].id || 1
        )
  }

  render() {
    const {
      match: {
        params: { id, form }
      },
      location,
      theme: { palette },
      classes,
      config: { valueTable },
      forms,
      path,
      // modified,
      // errors,
      add,
      formValues
    } = this.props

    const styles = {
      selected: {
        background: palette.secondary[100]
      }
    }

    const openMenu = Boolean(this.state.anchorEl)

    const { editType } = valueTable

    const currentActive = this.matchForm(forms, form, false)
    const viewEdit = qs.parse(location.search).view !== 'edit'
    const viewHistory = qs.parse(location.search).viewHistory !== 'history'

    return (
      <div>
        <List>
          {forms.map((sf, i) => {
            if (!!sf.hidden) return null
            const formName = this.matchForm(forms, sf.id)
            return viewEdit && viewHistory ? (
              <ListItem
                key={i}
                button
                style={
                  currentActive === sf.id ? { ...styles.selected } : undefined
                }
                // classes={{ default: classes.listItemDefault }}
              >
                <Link
                  style={{
                    textDecoration: 'none',
                    color: '#000',
                    width: 'calc(110%)',
                    // height: '44px',
                    display: 'flex'
                  }}
                  to={`${path}${id}/${formName}#${formName}`}
                  scroll={el =>
                    el.scrollIntoView({ behavior: 'instant', block: 'start' })
                  }
                >
                  <ListItemIcon classes={{ root: classes.listItemIconRoot }}>
                    <Icon>{sf.icon}</Icon>
                  </ListItemIcon>
                  <ListItemText
                    disableTypography
                    classes={{
                      root: classes.listItemTextRoot
                    }}
                    primary={sf.label}
                  />
                </Link>
                {((currentActive === sf.id &&
                  sf.name !== 'reg' &&
                  (formValues[`${sf.activeName}`] &&
                    formValues[`${sf.activeName}`].audit &&
                    formValues[`${sf.activeName}`].audit.active)) ||
                  (!add && _.isEmpty(formValues[`${sf.activeName}`]))) &&
                viewEdit &&
                !add ? (
                  <ListItemSecondaryAction
                    classes={{ root: classes.listItemSecondaryActionRoot }}
                  >
                    <IconButton onTouchTap={this.handleClick}>
                      <Icon style={{ color: '#000' }}>edit</Icon>
                    </IconButton>
                  </ListItemSecondaryAction>
                ) : null}
              </ListItem>
            ) : (
              <ListItem
                key={i}
                button
                style={
                  currentActive === sf.id ? { ...styles.selected } : undefined
                }
                // classes={{ default: classes.listItemDefault }}
              >
                <ListItemIcon classes={{ root: classes.listItemIconRoot }}>
                  <Icon>{sf.icon}</Icon>
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  classes={{
                    root: classes.listItemTextRoot
                  }}
                  primary={sf.label}
                />
                {((currentActive === sf.id &&
                  sf.name !== 'reg' &&
                  (formValues[`${sf.activeName}`] &&
                    formValues[`${sf.activeName}`].audit &&
                    formValues[`${sf.activeName}`].audit.active)) ||
                  (!add && _.isEmpty(formValues[`${sf.activeName}`]))) &&
                viewEdit &&
                !add ? (
                  <ListItemSecondaryAction
                    classes={{ root: classes.listItemSecondaryActionRoot }}
                  >
                    <IconButton onTouchTap={this.handleClick}>
                      <Icon style={{ color: '#000' }}>edit</Icon>
                    </IconButton>
                  </ListItemSecondaryAction>
                ) : null}
              </ListItem>
            )
          })}
        </List>
        <Menu
          anchorEl={this.state.anchorEl}
          open={openMenu}
          onClose={this.handleClose}
          style={{ zIndex: 5001 }}
        >
          {editType.map((e, i) => {
            return (
              <MenuItem
                key={`editMenu-${i + 1}`}
                value={`${i + 1}`}
                onClick={() => this.handleClose(i + 1, editType, currentActive)}
              >
                <Icon>{e.icon}</Icon>
                <Typography
                  style={{
                    marginLeft: 10,
                    display: 'inline-block'
                  }}
                >
                  {e.text}
                </Typography>
              </MenuItem>
            )
          })}
        </Menu>
      </div>
    )
  }
}

DrawerContent.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(withTheme()(DrawerContent))



// WEBPACK FOOTER //
// ./src/common/components/DrawerContent.js